module.exports = __webpack_public_path__ + "static/media/2B.f1f55ecf.png";